import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Type } from 'projects/c1-backend/src/app/db/type';
import { TypesService } from 'projects/c1-backend/src/app/services/types.service';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode, OrderingMode } from 'projects/core/src/include/structures';
import { DossierPhase } from '../../../dossier';
import { DossierPhasesService } from '../../../services/dossierphases.service';
import { DetailPhaseComponent } from './detail/detail.component';


@Component({
  selector: 'app-dossierphases',
  templateUrl: './phases.component.html',
  styleUrls: ['./phases.component.css']
})
export class PhasesComponent extends ModelList<DossierPhase> implements OnInit {

  constructor(
    private fb1: UntypedFormBuilder,
    private dossierphasesService: DossierPhasesService,
    private typesService:TypesService
  ) { 
    super(dossierphasesService,fb1);
    this.detailViewModal=DetailPhaseComponent;
  }

  type_dossier:Type[]=[];

  filter_search:Filter=new Filter();
  filter_status:Filter=new Filter();
  filter_id_type:Filter=new Filter();

  ngOnInit(): void {

    this.filter_search.mode=FilterMode.like;
    this.filter_search.fields=[];
    this.filter_search.fields.push("dp.title");
    this.filter_search.value="";
    this.filter.push(this.filter_search);

    this.filter_id_type.mode=FilterMode.like;
    this.filter_id_type.fields=[];
    this.filter_id_type.fields.push("dp.id_type");
    this.filter_id_type.value="";
    this.filter.push(this.filter_id_type);

    this.filter_status.mode=FilterMode.normal;
    this.filter_status.fields=[];
    this.filter_status.fields.push("dp.status");
    this.filter_status.value="1";
    this.filter.push(this.filter_status);

    this.ordering.field="id_type,ordering";
    this.ordering.mode=OrderingMode.ascendent;
  
    this.typesService.getTypes("dossier").subscribe((items)=>{
      this.type_dossier=items;
      this.getItems();

    });    
  }


  updateOrdering(record){
    this.update(record,()=>{
      this.getItems();
    });
  }


  override duplicate(record){
    this.dossierphasesService.getItem(record.id,true).subscribe((full_record)=>{
      super.duplicate(full_record);
    })
  }


  verifyFields() {
    // Verifica se vi sono campi con stesso name (ed in futuro magari anche altre cose)
    // da realizzare


  }

}
